<template>
<svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9.73242 12.6833L11.8658 10.55L9.73242 8.41663" stroke="#FF8300" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M3.33398 10.55H11.809" stroke="#FF8300" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M10 3.83337C13.6833 3.83337 16.6667 6.33337 16.6667 10.5C16.6667 14.6667 13.6833 17.1667 10 17.1667" stroke="#FF8300" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

</template>